import { useMemo } from "react";
import { UploadDocumentFieldFormik } from "../../../../renters/components/forms/fields/UploadDocumentFieldFormik";
import { UploadFieldVehicle } from "../vehicle-delivered/UploadFieldVehicle";

type VehiclesHistoricalRowProps = {
  name: string
  initialData: { type: string, content: string, }
  prefix: string
  vehicleId: string
}

export function VehiclesHistoricalRow(props: VehiclesHistoricalRowProps) {
  const vehicle = props.vehicleId;
  const pathToUpload = useMemo(() => `vehicles/${vehicle}/${props.prefix}`, [vehicle, props.prefix])

  return (
    <div>
      <UploadDocumentFieldFormik name={`${props.name}.content`} pathToUpload={pathToUpload}>
        {({ src, onNewFile, onRemoveClick }) => (
          <UploadFieldVehicle
            src={src}
            onNewFile={onNewFile}
            onRemoveClick={onRemoveClick}
          />
        )}
      </UploadDocumentFieldFormik>
    </div>
  )
}